import { yellow } from '@mui/material/colors';
import { makeObservable } from 'mobx';
import { MODO_PARTICIPACAO_ADVOGADO } from '../../dominio/ModoParticipacaoAdvogado';
import SituacaoInscricaoAdvogado, { SITUACAO_INSCRICAO_ADVOGADO } from '../../dominio/SituacaoInscricaoAdvogado';
import IconeAdvogado from '../sessao/icones/IconeAdvogado';
import IconeAdvogadoParticipacaoVirtual from '../sessao/icones/IconeAdvogadoParticipacaoVirtual';
import IconeAdvogadoSustentacaoOral from '../sessao/icones/IconeAdvogadoSustentacaoOral';
import IconeAdvogadoSustentacaoOralTelepresencial from '../sessao/icones/IconeAdvogadoSustentacaoOralTelepresencial';
import { Filtro } from './Filtro';
import IconeAdvogadoSustentacaoOralEletronica from '@/components/sessao/icones/IconeAdvogadoSustentacaoOralEletronica';
import IconeAdvogadoPedidoDestaque from '@/components/sessao/icones/IconeAdvogadoPedidoDestaque';

class FiltroAdvogadoNome extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Advogados inscritos para preferência/sustentação oral/participação virtual';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        let advs = new Set();

        registro.pedidoSustentacaoOral?.pedidosDetalhados?.forEach((pedido) => {
            pedido.advogados?.forEach((advogado) => {
                advs.add(advogado.nome);
            });
        });

        return Array.from(advs);
    }

    getIconeOpcao(registro, valor) {
        let presencas = new Set();
        let participacoes = new Set();

        this.store.rootStore.salaSessaoStore.processosSessao.forEach((processo) => {
            processo.pedidoSustentacaoOral?.pedidosDetalhados?.forEach((pedido) => {
                pedido.advogados?.forEach((adv) => {
                    if (adv.nome === valor) {
                        participacoes.add(adv.modoParticipacao);

                        if (
                            adv.modoParticipacao !== MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo &&
                            adv.modoParticipacao !== MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo &&
                            adv.modoParticipacao !== MODO_PARTICIPACAO_ADVOGADO.PEDIDO_DESTAQUE.codigo
                        ) {
                            presencas.add(adv.presente);
                        }
                    }
                });
            });
        });

        const cor = this._getCor(presencas);
        const modoParticipacao = this._getParticipacaoUnificada(participacoes);
        const tamanhoPadraoIcone = '24px';
        let tamanhoIcone = tamanhoPadraoIcone;

        switch (modoParticipacao) {
            case MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL.codigo:
                tamanhoIcone = '28px';
                return (
                    <span style={{ marginRight: this._calcularMargem(tamanhoPadraoIcone, tamanhoIcone) }}>
                        <IconeAdvogadoSustentacaoOral
                            removerTooltip
                            removerEstiloPadrao
                            style={{ width: tamanhoIcone, height: tamanhoIcone, fill: cor, color: cor }}
                        />
                    </span>
                );
            case MODO_PARTICIPACAO_ADVOGADO.TELEPRESENCIAL.codigo:
                tamanhoIcone = '28px';
                return (
                    <span style={{ marginRight: this._calcularMargem(tamanhoPadraoIcone, tamanhoIcone) }}>
                        <IconeAdvogadoSustentacaoOralTelepresencial
                            removerTooltip
                            removerEstiloPadrao
                            style={{ width: tamanhoIcone, height: tamanhoIcone, fill: cor, color: cor }}
                        />
                    </span>
                );
            case MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo:
                return (
                    <IconeAdvogadoParticipacaoVirtual
                        removerTooltip
                        removerEstiloPadrao
                        style={{ width: tamanhoIcone, height: tamanhoIcone, fill: cor, color: cor }}
                    />
                );
            case MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo:
                return (
                    <IconeAdvogadoSustentacaoOralEletronica
                        removerTooltip
                        removerEstiloPadrao
                        style={{ width: tamanhoIcone, height: tamanhoIcone, fill: cor, color: cor }}
                    />
                );
            case MODO_PARTICIPACAO_ADVOGADO.PEDIDO_DESTAQUE.codigo:
                return (
                    <IconeAdvogadoPedidoDestaque
                        removerTooltip
                        removerEstiloPadrao
                        style={{ width: tamanhoIcone, height: tamanhoIcone, fill: cor, color: cor }}
                    />
                );
            default:
                return (
                    <IconeAdvogado
                        removerTooltip
                        removerEstiloPadrao
                        style={{ width: tamanhoIcone, height: tamanhoIcone, fill: cor, color: cor }}
                    />
                );
        }
    }

    _calcularMargem(tamanhoPadraoIcone, tamanhoIcone) {
        let tamanhoPadraoIconeInt = tamanhoPadraoIcone.match(/(\d+)/)[0];
        let tamanhoIconeInt = tamanhoIcone.match(/(\d+)/)[0];
        let margem = Math.round((tamanhoPadraoIconeInt - tamanhoIconeInt) / 2);

        return `${margem}px`;
    }

    _getParticipacaoUnificada(participacoes) {
        if (participacoes.size === 1) {
            return participacoes.values().next().value;
        }

        return '';
    }

    _getCor(presencas) {
        const corMaisDeUm = yellow[800];

        if (presencas.size === 0) {
            return SITUACAO_INSCRICAO_ADVOGADO.INSCRITO.cor;
        }

        if (presencas.size === 1) {
            const valor = presencas.values().next().value;
            return SituacaoInscricaoAdvogado.getCorByCodigo(valor);
        }

        return corMaisDeUm;
    }
}

export default FiltroAdvogadoNome;
